var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisclaimerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#343B1B",
    cx: 13.5,
    cy: 13.5,
    r: 13.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.056 6.23c0 .305.002.61 0 .916 0 .086.03.113.114.113.23-.003.46-.005.69.002 1.073.033 1.985.443 2.765 1.165.17.156.159.32-.015.473-.113.1-.224.203-.337.303-.16.143-.288.144-.444 0a2.998 2.998 0 0 0-1.44-.76 3.522 3.522 0 0 0-.673-.073c-.831-.009-1.663 0-2.495-.006-.777-.006-1.361.34-1.748.989-.505.85-.49 1.725.005 2.578.254.44.668.764 1.156.906l4.03 1.26c.841.262 1.469.783 1.899 1.548.267.478.416 1.013.433 1.56.044 1.079-.313 2.004-1.102 2.743-.51.477-1.123.76-1.834.79-.277.013-.556.013-.834.017-.17.002-.17 0-.17.165v1.749c0 .237-.094.33-.33.332h-.475c-.196 0-.3-.103-.3-.3v-1.8c0-.147 0-.148-.146-.147-.484.005-.969.004-1.444-.11a4.255 4.255 0 0 1-1.869-.979c-.044-.038-.09-.074-.131-.115-.116-.117-.122-.281-.004-.396.142-.139.29-.271.442-.4.091-.077.229-.067.333.015.114.09.22.187.336.272.507.371 1.073.584 1.704.592.886.011 1.774.013 2.659.013 1.042 0 1.774-.77 1.989-1.664.196-.819.03-1.566-.517-2.215a1.916 1.916 0 0 0-.912-.592c-1.367-.427-2.734-.852-4.098-1.288-1.104-.353-1.782-1.126-2.135-2.21A3.286 3.286 0 0 1 9 10.647a3.496 3.496 0 0 1 .383-1.627c.273-.522.642-.962 1.144-1.284a2.975 2.975 0 0 1 1.648-.478c.22 0 .44-.003.66 0 .09 0 .119-.028.119-.119-.003-.603 0-1.207 0-1.81 0-.224.103-.327.33-.328h.474c.192.003.3.112.301.302v.926l-.003.002z",
    fill: "#343B1B",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclaimerIcon);
export default __webpack_public_path__ + "static/media/disclaimer-icon.360f3961aac50e894c02927fd8e6cda2.svg";
export { ForwardRef as ReactComponent };